import { denormalize } from "normalizr";
import schemas from "utils/schemas";

export const getFinancedChartFlags = (state, { documentId, siteId }) => {
  return state.document.decision.financedChart[`${documentId}-${siteId}`] || { isLoaded: false, loading: false };
};

export const getFinancedChart = (state, { documentId, siteId }) => {
  return state.entities.decision.financedChart[`${documentId}-${siteId}`] || {};
};

export const getFolderHasMultipleAssets = state => {
  const projection = state.currentFolder.financedOffers;
  if (projection && projection.isLoaded) {
    if (projection.ids?.length > 1) return true;
    const financedOffers = denormalize(projection.ids, [schemas.financedOffer], state.entities);
    return financedOffers[0]?.assets?.length > 1;
  }
  return false;
};
